<!--
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-12-07 15:15:11
 * @LastEditors: guanbowen 
 * @LastEditTime: 2023-02-28 17:00:20
-->
<template>
  <div class="x-input-contanier code-input flex-row flex-between">
    <el-input
      auto-complete="off"
      :placeholder="placeholder"
      v-model="sidentifyMode"
      @input="handleResult"
      @blur="handleResult"
    />
    <div @click="refreshCode()" class="code-components" :title="$t('login.clickSwtichCode')">
      <!-- <identify-code :identifyCode="identifyCode"></identify-code> -->
      <img :src="codeUrl" alt="" class="code-img" />
    </div>
  </div>
</template>
<script>
  export default {
    name: 'XCodeInput',
    model: {
      prop: 'result',
      event: 'handleResult'
    },
    props: {
      result: [String, Number],
      placeholder: {
        type: String,
        default: '请输入验证码'
      },
      identifyCodes: {
        type: Array,
        default: () => ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
      },
      codes: {
        type: String,
        default: ''
      },
      isRandom: {
        type: Boolean,
        default: true
      },
      codeUrl: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        // isSidentify: 0,
        sidentifyMode: '',
        identifyCode: ''
        // identifyCodes: [] //验证码出现的数字
      }
    },
    computed: {
      getData() {
        return this.result
      }
    },
    watch: {
      identifyCodes: {
        handler() {
          if (this.isRandom) {
            this.refreshCode()
          }
        },
        immediate: true,
        deep: true
      },
      getData(newValue) {
        if (newValue !== this.sidentifyMode) {
          this.sidentifyMode = this.result
        }
      },
      codes: {
        handler(val) {
          if (val) {
            this.identifyCode = val
          }
        },
        immediate: true,
        deep: true
      }
    },
    mounted() {
      // this.refreshCode()
    },
    methods: {
      handleResult() {
        this.$emit('handleResult', this.sidentifyMode)
      },
      // 生成随机数
      randomNum(min, max) {
        return Math.floor(Math.random() * (max + 1 - min) + min)
      },
      // 更新验证码
      refreshCode() {
        this.$emit('refreshCode')
        this.identifyCode = ''
        this.makeCode(this.identifyCodes, 4)
      },
      // 随机生成验证码字符串
      makeCode(data, len) {
        for (let i = 0; i < len; i += 1) {
          this.identifyCode += data[this.randomNum(0, data.length - 1)]
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .code-components {
    margin-left: 10px;
    .code-img {
      height: 100%;
      width: 100%;
    }
  }
</style>
